function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.758 5.376C29.379 4 31.758 5.376 27 4c0 0-1.9-2.638-4.758-2.752-3.195-.127-4.758 1.376-5.956 3.503-1.623 2.882.424 11.188-1.602 12.63C7.618 22.41.881 38.01 2.02 38.4c3.876-4.31 11.895-11.008 11.895-11.008-2.762 2.974 0 17.89.036 18.927.129 3.707-3.405 4.016-10.742 5.843.383 2.883 10.543 4.727 13.505.895 2.013-2.604 9.096 1.857 9.096 1.857L27 52.163c2.052-.497 5.463.802 8.326 1.376-1.167-1.753-3.005-3.573-5.948-5.504 1.302-3.354 1.522-12.58 1.19-20.641l13.085 6.88c-2.38-5.504-10.467-12.126-14.523-16.439-1.204-1.28-2.351-11.04-2.351-11.04 1.252-1.588 1.838-.662 4.978-1.419z",
  fillRule: "evenodd",
  stroke: "var(--primary-color, #000)",
  fill: "var(--primary-color, #000)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.484 12c2.366 1.9 5.934 1.937 8.327 0 4.107 12.469 3.568 27.338 1.19 35.971-2.676 1.186-5.28 2.542-9.517 0-4.872-12.204-.902-24.02 0-35.971z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "var(--primary-color, #000)"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 23.645,
  cy: 4.607,
  rx: 1.133,
  ry: 1.092,
  stroke: "#fff",
  fill: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgPenguin = function SvgPenguin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPenguin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Penguin.8797d48d.svg";
export { ForwardRef as ReactComponent };